export const SECTIONS = [
  { key: 'products', label: 'Products', icon: 'Package', table: 'products_c', description: 'Create catalog entries and keep new items as drafts.' },
  { key: 'variants', label: 'Pack variants', icon: 'Layers3', table: 'productvariants_c', description: 'Set pack sizes and prices from ₹400 to ₹4,000.' },
  { key: 'inventory', label: 'Inventory', icon: 'Boxes', table: 'inventory_c', description: 'Enter physical stock counts and low-stock thresholds.' },
  { key: 'orders', label: 'Orders', icon: 'ReceiptText', table: 'orders_c', description: 'Review orders and update fulfilment status.' },
  { key: 'customers', label: 'Customers', icon: 'UsersRound', table: 'customers_c', description: 'View contact and consent details for support.' },
  { key: 'offers', label: 'Discounts', icon: 'TicketPercent', table: 'discounts_c', description: 'Configure offers for future server-validated checkout.' },
  { key: 'settings', label: 'Store settings', icon: 'SlidersHorizontal', table: 'storesettings_c', description: 'Manage public contact and shipping display settings.' },
  { key: 'returns', label: 'Returns', icon: 'RotateCcw', table: 'returnrequests_c', description: 'Returns stay disabled until the store policy is approved.' },
];

export const FIELDS = {
  products_c: [
    { key: 'Name', label: 'Product name', type: 'text', required: true },
    { key: 'category_c', label: 'Category', type: 'select', options: ['Tea', 'Coffee'], required: true },
    { key: 'description_c', label: 'Description', type: 'textarea' },
    { key: 'tasting_notes_c', label: 'Tasting notes', type: 'textarea' },
    { key: 'brew_guide_c', label: 'Brew guide', type: 'textarea' },
    { key: 'image_url_c', label: 'Product image URL', type: 'text' },
    { key: 'publication_status_c', label: 'Publication status', type: 'select', options: ['Draft', 'Published', 'Archived'], required: true },
  ],
  productvariants_c: [
    { key: 'Name', label: 'Variant name', type: 'text', required: true },
    { key: 'sku_c', label: 'SKU', type: 'text' },
    { key: 'pack_size_c', label: 'Pack size', type: 'text', required: true },
    { key: 'price_c', label: 'Price (₹400–₹4,000)', type: 'number', required: true },
    { key: 'is_active_c', label: 'Active', type: 'checkbox' },
    { key: 'is_public_c', label: 'Visible in public catalog', type: 'checkbox' },
    { key: 'product_c', label: 'Product', type: 'lookup', source: 'products_c', required: true },
  ],
  inventory_c: [
    { key: 'Name', label: 'Stock record name', type: 'text', required: true },
    { key: 'on_hand_c', label: 'On-hand quantity', type: 'number', required: true },
    { key: 'reserved_c', label: 'Reserved quantity', type: 'number', required: true },
    { key: 'low_stock_threshold_c', label: 'Low-stock threshold', type: 'number', required: true },
    { key: 'variant_c', label: 'Product variant', type: 'lookup', source: 'productvariants_c', required: true },
  ],
  discounts_c: [
    { key: 'Name', label: 'Offer name', type: 'text', required: true },
    { key: 'code_c', label: 'Offer code', type: 'text', required: true },
    { key: 'discount_type_c', label: 'Discount type', type: 'select', options: ['Percent', 'Flat'], required: true },
    { key: 'value_c', label: 'Discount value', type: 'number', required: true },
    { key: 'minimum_order_c', label: 'Minimum order (₹)', type: 'number' },
    { key: 'starts_at_c', label: 'Starts at', type: 'datetime' },
    { key: 'ends_at_c', label: 'Ends at', type: 'datetime' },
    { key: 'active_c', label: 'Active', type: 'checkbox' },
  ],
  storesettings_c: [
    { key: 'Name', label: 'Settings name', type: 'text', required: true },
    { key: 'whatsapp_phone_c', label: 'WhatsApp number', type: 'text' },
    { key: 'support_email_c', label: 'Support email', type: 'email' },
    { key: 'upi_id_c', label: 'UPI ID (display only)', type: 'text' },
    { key: 'upi_qr_image_c', label: 'UPI QR image URL (display only)', type: 'text' },
    { key: 'shipping_fee_c', label: 'Shipping below threshold (₹)', type: 'number', required: true },
    { key: 'free_shipping_threshold_c', label: 'Free shipping threshold (₹)', type: 'number', required: true },
    { key: 'cod_enabled_c', label: 'Cash on delivery', type: 'locked' },
    { key: 'returns_enabled_c', label: 'Returns', type: 'locked' },
  ],
};

export const COLUMNS = {
  products_c: ['Name', 'category_c', 'publication_status_c'],
  productvariants_c: ['Name', 'sku_c', 'pack_size_c', 'price_c', 'is_active_c', 'product_c'],
  inventory_c: ['Name', 'on_hand_c', 'reserved_c', 'low_stock_threshold_c', 'variant_c'],
  orders_c: ['Name', 'order_status_c', 'payment_method_c', 'payment_status_c', 'subtotal_c', 'shipping_c', 'discount_c', 'total_c', 'customer_c', 'delivery_address_snapshot_c', 'CreatedOn'],
  customers_c: ['Name', 'verified_phone_c', 'delivery_address_c', 'privacy_notice_version_c', 'privacy_acknowledged_at_c', 'marketing_consent_c', 'CreatedOn'],
  discounts_c: ['Name', 'code_c', 'discount_type_c', 'value_c', 'active_c'],
  storesettings_c: ['Name', 'whatsapp_phone_c', 'shipping_fee_c', 'free_shipping_threshold_c'],
  returnrequests_c: ['Name', 'request_status_c', 'reason_c', 'CreatedOn'],
};

export const ORDER_TRANSITIONS = {
  'Pending Payment': [],
  'Payment Verified': ['Confirmed', 'Cancelled'],
  'Pending Review': ['Confirmed', 'Cancelled'],
  Confirmed: ['Processing', 'Cancelled'],
  Processing: ['Shipped', 'Cancelled'],
  Shipped: ['Delivered'],
  Delivered: [],
  Cancelled: [],
  Expired: [],
};

export const READ_ONLY_SECTIONS = new Set(['orders', 'customers', 'returns']);

export const TABLES = {
  products_c: 'products_c',
  productvariants_c: 'productvariants_c',
  inventory_c: 'inventory_c',
  orders_c: 'orders_c',
  customers_c: 'customers_c',
  discounts_c: 'discounts_c',
  storesettings_c: 'storesettings_c',
  returnrequests_c: 'returnrequests_c',
};

export const PRODUCT_FIELDS = ['Name', 'category_c', 'description_c', 'tasting_notes_c', 'brew_guide_c', 'image_url_c', 'publication_status_c'];

export function unwrap(response) {
  if (!response?.success) throw new Error(response?.message || 'Could not load store records.');
  return response.data ?? [];
}

export function readLookup(value) {
  if (!value) return '';
  return typeof value === 'object' ? String(value.Id ?? '') : String(value);
}

export function showValue(value, field) {
  if (value == null || value === '') return '—';
  if (['price_c', 'total_c', 'shipping_fee_c', 'free_shipping_threshold_c', 'value_c', 'minimum_order_c'].includes(field)) return '₹' + Number(value).toLocaleString('en-IN');
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'object') return value.Name || 'Linked record';
  return String(value);
}

export function emptyDraft(fields) {
  return Object.fromEntries(fields.map((field) => [field.key, field.type === 'checkbox' || field.type === 'locked' ? false : '']));
}